export default __webpack_public_path__ + "1a100f4.png";